var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_825_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.27993 0 0 6.27993 0 14C0 21.7201 6.27993 28 14 28C21.7201 28 28 21.719 28 14C28 6.28102 21.7201 0 14 0ZM14 25.8311C7.47715 25.8311 2.16885 20.5239 2.16885 14C2.16885 7.47605 7.47715 2.16885 14 2.16885C20.5239 2.16885 25.8311 7.47605 25.8311 14C25.8311 20.5239 20.5229 25.8311 14 25.8311Z",
    fill: "#E00E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4227 9.13076C19.9813 8.72952 19.2949 8.76096 18.8915 9.20448L12.2764 16.4886L9.0806 13.2397C8.65874 12.8124 7.9734 12.8059 7.54722 13.2267C7.11995 13.6464 7.11344 14.3328 7.53421 14.7601L11.5347 18.8267C11.7396 19.0349 12.0172 19.1509 12.3078 19.1509C12.3143 19.1509 12.3219 19.1509 12.3284 19.152C12.6277 19.1455 12.9097 19.0176 13.1103 18.7963L20.4963 10.6631C20.8987 10.2184 20.8662 9.5331 20.4227 9.13076Z",
    fill: "#E00E3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_825_923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReady);
export default __webpack_public_path__ + "static/media/ready.9ddce4df81bb8bde209144f0e14bc78e.svg";
export { ForwardRef as ReactComponent };